import React, { useState } from 'react';

// SVG Icons
const ScaleIcon = () => (<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M16 16l3-8 3 8c-.87.65-1.92 1-3 1s-2.13-.35-3-1Z"/><path d="M2 16l3-8 3 8c-.87.65-1.92 1-3 1s-2.13-.35-3-1Z"/><path d="M7 21h10"/><path d="M12 3v18"/><path d="M3 7h2c2 0 5-1 7-2 2 1 5 2 7 2h2"/></svg>);
const SearchIcon = () => (<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="11" cy="11" r="8"/><path d="m21 21-4.3-4.3"/></svg>);
const AlertIcon = () => (<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" x2="12" y1="8" y2="12"/><line x1="12" x2="12.01" y1="16" y2="16"/></svg>);
const CheckIcon = () => (<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><path d="m9 11 3 3L22 4"/></svg>);
const BookIcon = () => (<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1 0-5H20"/></svg>);
const FileTextIcon = () => (<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z"/><polyline points="14 2 14 8 20 8"/><line x1="16" x2="8" y1="13" y2="13"/><line x1="16" x2="8" y1="17" y2="17"/><line x1="10" x2="8" y1="9" y2="9"/></svg>);
const MessageCircleIcon = () => (<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="m3 21 1.9-5.7a8.5 8.5 0 1 1 3.8 3.8z"/></svg>);
const SparklesIcon = () => (<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="m12 3-1.912 5.813a2 2 0 0 1-1.275 1.275L3 12l5.813 1.912a2 2 0 0 1 1.275 1.275L12 21l1.912-5.813a2 2 0 0 1 1.275-1.275L21 12l-5.813-1.912a2 2 0 0 1-1.275-1.275L12 3Z"/><path d="M5 3v4"/><path d="M3 5h4"/><path d="M19 17v4"/><path d="M17 19h4"/></svg>);
const MailIcon = () => (<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect width="20" height="16" x="2" y="4" rx="2"/><path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/></svg>);
const SendIcon = () => (<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="m22 2-7 20-4-9-9-4Z"/><path d="M22 2 11 13"/></svg>);export default function App() {
    
    // 🟢 ຍິງໄປຫາ Worker ແທນ
    const API_URL = `/api`;

// 🟢 ໃສ່ ACCESS KEY ຂອງ WEB3FORMS ຢູ່ບ່ອນນີ້ (ສຳລັບສົ່ງອີເມວຕິຊົມ)
    const web3FormsKey = "563b5e46-9eee-4885-9b5f-48ab4a6bef38";

    const [activeTab, setActiveTab] = useState('qa');

    // States
    const [query, setQuery] = useState('');
    const [loading, setLoading] = useState(false);
    const [result, setResult] = useState(null);
    const [error, setError] = useState('');

    const [draftType, setDraftType] = useState('ສັນຍາກູ້ຢືມເງິນ');
    const [draftDetails, setDraftDetails] = useState('');
    const [draftResult, setDraftResult] = useState('');
    const [draftLoading, setDraftLoading] = useState(false);
    const [draftError, setDraftError] = useState('');
    const [copyStatus, setCopyStatus] = useState('ສຳເນົາ (Copy)');

    const [simplifyText, setSimplifyText] = useState('');
    const [simplifyResult, setSimplifyResult] = useState('');
    const [simplifyLoading, setSimplifyLoading] = useState(false);
    const [simplifyError, setSimplifyError] = useState('');

    // States for Feature 4 (Feedback Form)
    const [feedbackName, setFeedbackName] = useState('');
    const [feedbackContact, setFeedbackContact] = useState('');
    const [feedbackMessage, setFeedbackMessage] = useState('');
    const [feedbackLoading, setFeedbackLoading] = useState(false);
    const [feedbackStatus, setFeedbackStatus] = useState('');

    // API Call Function
    const fetchAPI = async (payload) => {
        const response = await fetch(API_URL, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload)
        });

        if (!response.ok) {
            throw new Error(`HTTP Error: ${response.status}`);
        }
        return await response.json();
    };

    // --- Feature 1: Q&A ---
    const fetchLawAdvice = async () => {
        if (!query.trim()) { setError('ກະລຸນາປ້ອນຄຳຖາມກ່ອນ.'); return; }
        setLoading(true); setError(''); setResult(null);

        const systemInstruction = `You are an expert legal advisor specializing in the laws of the Lao PDR. Your task is to analyze the user's situation and provide legal advice based on the updated Lao laws. 
        Respond STRICTLY in Lao language using the following JSON format ONLY:
        {
            "law_category": "ກົດໝາຍອາຍາ ຫຼື ກົດໝາຍແພ່ງ",
            "article_reference": "ມາດຕາທີ່ກ່ຽວຂ້ອງ",
            "detailed_explanation": "ອະທິບາຍລະອຽດ",
            "penalties_or_fines": "ໂທດປັບໃໝ ຫຼື ຈຳຄຸກ (ຖ້າມີ)",
            "advice_if_innocent": "ຄຳແນະນຳ"
        }`;

        const payload = {
            contents: [{ parts: [{ text: query }] }],
            systemInstruction: { parts: [{ text: systemInstruction }] },
            generationConfig: { responseMimeType: "application/json" }
        };

        try {
            const data = await fetchAPI(payload);
            const textResponse = data.candidates?.[0]?.content?.parts?.[0]?.text;
            setResult(JSON.parse(textResponse));
        } catch (err) {
            setError(`ເກີດຂໍ້ຜິດພາດ: ${err.message}`);
        } finally {
            setLoading(false);
        }
    };
    // --- Feature 2: Document Drafter ---
    const generateDocument = async () => {
        if (!draftDetails.trim()) { setDraftError('ກະລຸນາປ້ອນລາຍລະອຽດກ່ອນ.'); return; }
        setDraftLoading(true); setDraftError(''); setDraftResult(''); setCopyStatus('ສຳເນົາ (Copy)');

        const systemInstruction = `You are an expert legal drafter in the Lao PDR. Draft a formal, legally sound "${draftType}" in the Lao language based on the user's details. Use standard legal formatting.`;
        
        const payload = {
            contents: [{ parts: [{ text: draftDetails }] }],
            systemInstruction: { parts: [{ text: systemInstruction }] }
        };

        try {
            const data = await fetchAPI(payload);
            const textResponse = data.candidates?.[0]?.content?.parts?.[0]?.text;
            setDraftResult(textResponse);
        } catch (err) {
            setDraftError(err.message);
        } finally {
            setDraftLoading(false);
        }
    };

    const handleCopy = () => {
        const textArea = document.createElement("textarea");
        textArea.value = draftResult;
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand("copy");
        document.body.removeChild(textArea);
        setCopyStatus('ສຳເນົາສຳເລັດ!');
        setTimeout(() => setCopyStatus('ສຳເນົາ (Copy)'), 2000);
    };

    // --- Feature 3: Simplifier ---
    const simplifyLegalText = async () => {
        if (!simplifyText.trim()) { setSimplifyError('ກະລຸນາປ້ອນເນື້ອໃນກ່ອນ.'); return; }
        setSimplifyLoading(true); setSimplifyError(''); setSimplifyResult('');

        const systemInstruction = `You are a friendly legal assistant in Laos. Explain the complex legal text provided by the user in simple, everyday Lao language.`;
        
        const payload = {
            contents: [{ parts: [{ text: simplifyText }] }],
            systemInstruction: { parts: [{ text: systemInstruction }] }
        };

        try {
            const data = await fetchAPI(payload);
            const textResponse = data.candidates?.[0]?.content?.parts?.[0]?.text;
            setSimplifyResult(textResponse);
        } catch (err) {
            setSimplifyError(err.message);
        } finally {
            setSimplifyLoading(false);
        }
    };
    // --- Feature 4: Feedback Form (Web3Forms) ---
    const submitFeedback = async (e) => {
        e.preventDefault();
        if (!feedbackMessage.trim()) return;
        
        setFeedbackLoading(true);
        setFeedbackStatus('');

        try {
            const response = await fetch("https://api.web3forms.com/submit", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json",
                },
                body: JSON.stringify({
                    access_key: web3FormsKey,
                    subject: "💡 ມີຄຳຕິຊົມໃໝ່ຈາກເວັບໄຊ ທີ່ປຶກສາກົດໝາຍ AI",
                    from_name: "Lao Law AI Feedback",
                    name: feedbackName || "ບໍ່ລະບຸຊື່",
                    email_or_phone: feedbackContact || "ບໍ່ລະບຸຊ່ອງທາງຕິດຕໍ່",
                    message: feedbackMessage,
                }),
            });
            const result = await response.json();
            if (result.success) {
                setFeedbackStatus('success');
                setFeedbackName('');
                setFeedbackContact('');
                setFeedbackMessage('');
            } else {
                setFeedbackStatus('error');
            }
        } catch (error) {
            setFeedbackStatus('error');
        } finally {
            setFeedbackLoading(false);
            setTimeout(() => setFeedbackStatus(''), 5000);
        }
    };
    return (
        <div className="min-h-screen pb-12 bg-slate-50">
            <header className="bg-slate-900 text-white shadow-lg">
                <div className="max-w-4xl mx-auto px-4 py-8">
                    <div className="flex items-center gap-4 mb-2">
                        <div className="bg-blue-600 p-3 rounded-xl">
                            <ScaleIcon />
                        </div>
                        <div>
                            <h1 className="text-2xl md:text-3xl font-bold">ທີ່ປຶກສາກົດໝາຍຂອງ ສປປ ລາວ</h1>
                            <p className="text-slate-300 text-sm md:text-base mt-1">
                                ລະບົບຖາມ-ຕອບ, ຮ່າງເອກະສານ ແລະ ອະທິບາຍກົດໝາຍ
                            </p>
                        </div>
                    </div>
                    
                    <div className="flex overflow-x-auto mt-6 gap-2 border-b border-slate-700 pb-2 scrollbar-hide">
                        <button onClick={() => setActiveTab('qa')} className={`flex items-center gap-2 px-4 py-2 rounded-lg whitespace-nowrap transition-colors ${activeTab === 'qa' ? 'bg-blue-600 text-white' : 'text-slate-300 hover:bg-slate-800'}`}>
                            <MessageCircleIcon /> ປຶກສາບັນຫາ
                        </button>
                        <button onClick={() => setActiveTab('draft')} className={`flex items-center gap-2 px-4 py-2 rounded-lg whitespace-nowrap transition-colors ${activeTab === 'draft' ? 'bg-blue-600 text-white' : 'text-slate-300 hover:bg-slate-800'}`}>
                            <FileTextIcon />  ຮ່າງເອກະສານກົດໝາຍ
                        </button>
                        <button onClick={() => setActiveTab('simplify')} className={`flex items-center gap-2 px-4 py-2 rounded-lg whitespace-nowrap transition-colors ${activeTab === 'simplify' ? 'bg-blue-600 text-white' : 'text-slate-300 hover:bg-slate-800'}`}>
                            <FileTextIcon /> ແປພາສາກົດໝາຍ
                        </button>
                        {/* 🟢 ປຸ່ມລິ້ງໄປ LaoGrammar.com */}
                        <a 
                            href="https://laogrammar.com" 
                            target="_blank" 
                            rel="noopener noreferrer" 
                            className="flex items-center gap-2 px-4 py-2 rounded-lg whitespace-nowrap text-slate-300 hover:bg-slate-800 hover:text-white transition-colors"
                        >
                            <CheckIcon /> ກວດໄວຍະກອນ
                        </a>
                        <button onClick={() => setActiveTab('feedback')} className={`flex items-center gap-2 px-4 py-2 rounded-lg whitespace-nowrap transition-colors ${activeTab === 'feedback' ? 'bg-blue-600 text-white' : 'text-slate-300 hover:bg-slate-800'}`}>
                            <MailIcon /> ສົ່ງຄຳຕິຊົມ
                        </button>
                    </div>
                </div>
            </header>

            <main className="max-w-4xl mx-auto px-4 mt-8">
                
                {/* TAB 1: Q&A */}
                {activeTab === 'qa' && (
                    <div className="law-card-enter">
                        <div className="bg-white rounded-2xl shadow-sm border border-slate-200 p-6 mb-8">
                            <label htmlFor="query" className="block text-slate-700 font-semibold mb-2">
                                ອະທິບາຍເຫດການ ຫຼື ຄຳຖາມຂອງທ່ານ:
                            </label>
                            <textarea
                                id="query"
                                rows="4"
                                className="w-full rounded-xl border-slate-300 border p-4 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all resize-none outline-none text-slate-700"
                                placeholder="ຕົວຢ່າງ: ຂ້ອຍຖືກຄົນຢືມເງິນໄປ 50 ລ້ານກີບ ແລ້ວບໍ່ຍອມຈ່າຍຄືນ..."
                                value={query}
                                onChange={(e) => setQuery(e.target.value)}
                            ></textarea>
                            
                            <div className="mt-4 flex justify-end items-center">
                                <button
                                    onClick={fetchLawAdvice}
                                    disabled={loading}
                                    className="bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 px-6 rounded-xl flex items-center gap-2 transition-all disabled:opacity-70 shadow-sm"
                                >
                                    {loading ? (
                                        <><div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></div> ກຳລັງວິເຄາະຂໍ້ມູນ...</>
                                    ) : (
                                        <><SearchIcon /> ວິເຄາະກົດໝາຍ</>
                                    )}
                                </button>
                            </div>
                        </div>

                        {error && (
                            <div className="bg-red-50 text-red-600 p-4 rounded-xl mb-8 flex items-center gap-3 border border-red-200">
                                <AlertIcon />
                                <p className="font-semibold break-words">{error}</p>
                            </div>
                        )}

                        {result && (
                            <div className="bg-white rounded-2xl shadow-lg border border-slate-100 overflow-hidden mb-8">
                                <div className={`p-4 flex items-center gap-3 text-white font-bold text-lg ${
                                    result.law_category?.includes('ອາຍາ') ? 'bg-red-600' : 
                                    result.law_category?.includes('ແພ່ງ') ? 'bg-blue-600' : 'bg-slate-600'
                                }`}>
                                    <BookIcon />
                                    <span>ຈັດຢູ່ໃນປະເພດ: {result.law_category}</span>
                                </div>

                                <div className="p-6 md:p-8 space-y-8">
                                    <div>
                                        <h3 className="text-slate-800 font-bold flex items-center gap-2 mb-2 text-lg">
                                            <span className="bg-slate-100 p-1.5 rounded-lg text-slate-600"><BookIcon /></span>
                                            ມາດຕາທີ່ກ່ຽວຂ້ອງ
                                        </h3>
                                        <p className="text-slate-700 leading-relaxed bg-slate-50 p-4 rounded-xl border border-slate-100">
                                            {result.article_reference}
                                        </p>
                                    </div>
                                    <div>
                                        <h3 className="text-slate-800 font-bold flex items-center gap-2 mb-2 text-lg">
                                            <span className="bg-slate-100 p-1.5 rounded-lg text-slate-600"><AlertIcon /></span>
                                            ອະທິບາຍລະອຽດ
                                        </h3>
                                        <p className="text-slate-700 leading-relaxed">
                                            {result.detailed_explanation}
                                        </p>
                                    </div>
                                    <div>
                                        <h3 className={`font-bold flex items-center gap-2 mb-2 text-lg ${result.law_category?.includes('ອາຍາ') ? 'text-red-700' : 'text-blue-700'}`}>
                                            <span className={`p-1.5 rounded-lg ${result.law_category?.includes('ອາຍາ') ? 'bg-red-50 text-red-600' : 'bg-blue-50 text-blue-600'}`}>
                                                <AlertIcon />
                                            </span>
                                            {result.law_category?.includes('ອາຍາ') ? 'ໂທດປັບໃໝ ແລະ ຈຳຄຸກ' : 'ຄວາມຮັບຜິດຊອບ ແລະ ຄ່າເສຍຫາຍ'}
                                        </h3>
                                        <div className={`p-4 rounded-xl border ${result.law_category?.includes('ອາຍາ') ? 'bg-red-50/50 border-red-100 text-red-900' : 'bg-blue-50/50 border-blue-100 text-blue-900'}`}>
                                            <p className="leading-relaxed whitespace-pre-line">
                                                {result.penalties_or_fines}
                                            </p>
                                        </div>
                                    </div>
                                    <div>
                                        <h3 className="text-green-700 font-bold flex items-center gap-2 mb-2 text-lg">
                                            <span className="bg-green-50 p-1.5 rounded-lg text-green-600"><CheckIcon /></span>
                                            ຄຳແນະນຳ (ຖ້າທ່ານບໍ່ມີຄວາມຜິດ / ວິທີແກ້ໄຂ)
                                        </h3>
                                        <div className="bg-green-50/50 border border-green-100 p-4 rounded-xl text-green-900">
                                            <p className="leading-relaxed whitespace-pre-line">
                                                {result.advice_if_innocent}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                        <div className="bg-slate-50 p-4 text-center text-sm text-slate-500 border border-slate-200 rounded-xl mt-4">
                            ໝາຍເຫດ: ຂໍ້ມູນນີ້ສ້າງຂຶ້ນໂດຍລະບົບຄົ້ນຫາຂໍ້ມູນທາງອິນເຕີເນັດ ເພື່ອເປັນທາງເລືອກທີ່ໄວສຳລັບທ່ານ ແຕ່ກໍ່ອາດຈະມີຂໍ້ຜິດພາດທີ່ປາສະຈາກບໍ່ໄດ້. ສະນັ້ນກະລຸນາປຶກສາທະນາຍຄວາມຕົວຈິງເພື່ອການດຳເນີນຄະດີທາງກົດໝາຍ.
                        </div>
                    </div>
                )}

                {/* TAB 2: Document Drafter */}
                {activeTab === 'draft' && (
                    <div className="law-card-enter">
                        <div className="bg-white rounded-2xl shadow-sm border border-slate-200 p-6 mb-8">
                            <div className="mb-4">
                                <label className="block text-slate-700 font-semibold mb-2">ປະເພດເອກະສານ:</label>
                                <select 
                                    className="w-full md:w-1/2 rounded-xl border-slate-300 border p-3 focus:ring-2 focus:ring-blue-500 outline-none bg-white animate-none text-slate-700"
                                    value={draftType}
                                    onChange={(e) => setDraftType(e.target.value)}
                                >
                                    <option value="ສັນຍາກູ້ຢືມເງິນ">ສັນຍາກູ້ຢືມເງິນ</option>
                                    <option value="ສັນຍາເຊົ່າເຮືອນ/ທີ່ດິນ">ສັນຍາເຊົ່າເຮືອນ/ທີ່ດິນ</option>
                                    <option value="ໜັງສືມອບສິດ">ໜັງສືມອບສິດ</option>
                                    <option value="ສັນຍາຊື້ຂາຍລົດ">ສັນຍາຊື້ຂາຍລົດ</option>
                                    <option value="ສັນຍາຈ້າງງານ">ສັນຍາຈ້າງງານ</option>
                                </select>
                            </div>
                            <label className="block text-slate-700 font-semibold mb-2">
                                ລາຍລະອຽດທີ່ຕ້ອງການໃສ່ໃນສັນຍາ:
                            </label>
                            <textarea
                                rows="4"
                                className="w-full rounded-xl border-slate-300 border p-4 focus:ring-2 focus:ring-blue-500 transition-all resize-none outline-none text-slate-700"
                                placeholder="ຕົວຢ່າງ: ທ້າວ ກ (ຜູ້ໃຫ້ຢືມ) ໃຫ້ ທ້າວ ຂ (ຜູ້ຢືມ) ຢືມເງິນ 50,000,000 ກີບ..."
                                value={draftDetails}
                                onChange={(e) => setDraftDetails(e.target.value)}
                            ></textarea>
                            <div className="mt-4 flex justify-end items-center">
                                <button
                                    onClick={generateDocument}
                                    disabled={draftLoading}
                                    className="bg-purple-600 hover:bg-purple-700 text-white font-semibold py-3 px-6 rounded-xl flex items-center gap-2 transition-all disabled:opacity-70 shadow-sm"
                                >
                                    {draftLoading ? (
                                        <><div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></div> ກຳລັງສ້າງເອກະສານ...</>
                                    ) : (
                                        <><FileTextIcon /> ຮ່າງເອກະສານ</>
                                    )}
                                </button>
                            </div>
                        </div>
                        {draftError && (
                            <div className="bg-red-50 text-red-600 p-4 rounded-xl mb-8 flex items-center gap-3 border border-red-200">
                                <AlertIcon />
                                <p className="font-semibold">{draftError}</p>
                            </div>
                        )}
                        {draftResult && (
                            <div className="bg-white rounded-2xl shadow-lg border border-slate-100 p-8">
                                <div className="flex justify-between items-center mb-6 border-b pb-4">
                                    <h3 className="text-xl font-bold text-slate-800 flex items-center gap-2">
                                        <span className="bg-purple-100 text-purple-600 p-1.5 rounded-lg"><FileTextIcon /></span>
                                        ຜົນການຮ່າງເອກະສານ
                                    </h3>
                                    <button 
                                        onClick={handleCopy}
                                        className="text-sm bg-slate-100 hover:bg-slate-200 text-slate-700 py-1.5 px-3 rounded-lg font-medium transition-colors"
                                    >
                                        {copyStatus}
                                    </button>
                                </div>
                                <div className="prose max-w-none text-slate-700 whitespace-pre-wrap font-serif text-sm md:text-base leading-relaxed">
                                    {draftResult}
                                </div>
                            </div>
                        )}
                    </div>
                )}

                {/* TAB 3: Simplifier */}
                {activeTab === 'simplify' && (
                    <div className="law-card-enter">
                        <div className="bg-white rounded-2xl shadow-sm border border-slate-200 p-6 mb-8">
                            <label className="block text-slate-700 font-semibold mb-2">
                                ວາງຂໍ້ຄວາມ ຫຼື ມາດຕາກົດໝາຍທີ່ອ່ານແລ້ວເຂົ້າໃຈຍາກລົງບ່ອນນີ້:
                            </label>
                            <textarea
                                rows="4"
                                className="w-full rounded-xl border-slate-300 border p-4 focus:ring-2 focus:ring-emerald-500 transition-all resize-none outline-none text-slate-700"
                                placeholder="ວາງເນື້ອໃນກົດໝາຍທີ່ຕ້ອງການແປເປັນພາສາຄົນທົ່ວໄປ..."
                                value={simplifyText}
                                onChange={(e) => setSimplifyText(e.target.value)}
                            ></textarea>
                            <div className="mt-4 flex justify-end items-center">
                                <button
                                    onClick={simplifyLegalText}
                                    disabled={simplifyLoading}
                                    className="bg-emerald-600 hover:bg-emerald-700 text-white font-semibold py-3 px-6 rounded-xl flex items-center gap-2 transition-all disabled:opacity-70 shadow-sm"
                                >
                                    {simplifyLoading ? (
                                        <><div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></div> ກຳລັງແປຂໍ້ຄວາມ...</>
                                    ) : (
                                        <><FileTextIcon /> ອະທິບາຍໃຫ້ເຂົ້າໃຈງ່າຍ</>
                                    )}
                                </button>
                            </div>
                        </div>
                        {simplifyError && (
                            <div className="bg-red-50 text-red-600 p-4 rounded-xl mb-8 flex items-center gap-3 border border-red-200">
                                <AlertIcon />
                                <p className="font-semibold">{simplifyError}</p>
                            </div>
                        )}
                        {simplifyResult && (
                            <div className="bg-white rounded-2xl shadow-lg border border-slate-100 p-8">
                                <h3 className="text-xl font-bold text-slate-800 mb-4 flex items-center gap-2">
                                    <span className="bg-emerald-100 text-emerald-600 p-1.5 rounded-lg"><SearchIcon /></span>
                                    ສະຫຼຸບເນື້ອໃນໃຫ້ເຂົ້າໃຈງ່າຍ
                                </h3>
                                <div className="bg-emerald-50/50 p-6 rounded-xl border border-emerald-100 text-slate-800 whitespace-pre-wrap leading-relaxed text-sm md:text-base">
                                    {simplifyResult}
                                </div>
                            </div>
                        )}
                    </div>
                )}
                {/* TAB 4: Feedback Form */}
                {activeTab === 'feedback' && (
                    <div className="law-card-enter">
                        <div className="bg-white rounded-2xl shadow-sm border border-slate-200 p-6 md:p-8 mb-8">
                            <h2 className="text-xl font-bold text-slate-800 flex items-center gap-2 mb-6 pb-4 border-b border-slate-100">
                                <span className="text-blue-600"><MessageCircleIcon /></span>
                                ສົ່ງຂໍ້ຄວາມຕິຊົມ ຫຼື ແນະນຳເຖິງຜູ້ພັດທະນາ
                            </h2>

                            {feedbackStatus === 'success' && (
                                <div className="bg-green-50 text-green-700 p-4 rounded-xl mb-6 flex items-center gap-3 border border-green-200">
                                    <CheckIcon />
                                    <p className="font-semibold">ຂໍ້ຄວາມຂອງທ່ານຖືກສົ່ງຮຽບຮ້ອຍແລ້ວ. ຂໍຂອບໃຈ!</p>
                                </div>
                            )}

                            {feedbackStatus === 'error' && (
                                <div className="bg-red-50 text-red-600 p-4 rounded-xl mb-6 flex items-center gap-3 border border-red-200">
                                    <AlertIcon />
                                    <p className="font-semibold">ເກີດຂໍ້ຜິດພາດໃນການສົ່ງຂໍ້ຄວາມ. ກະລຸນາລອງໃໝ່ພາຍຫຼັງ.</p>
                                </div>
                            )}

                            <form onSubmit={submitFeedback} className="space-y-6">
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                    <div>
                                        <label className="block text-slate-600 text-sm font-medium mb-2 text-left">
                                            ຊື່ຂອງທ່ານ
                                        </label>
                                        <input 
                                            type="text" 
                                            placeholder="ພິມຊື່ ຫຼື ນາມແຝງ" 
                                            className="w-full rounded-xl border-slate-200 border p-3.5 focus:ring-2 focus:ring-slate-400 focus:border-slate-400 outline-none text-slate-700 bg-slate-50/50"
                                            value={feedbackName}
                                            onChange={(e) => setFeedbackName(e.target.value)}
                                        />
                                    </div>
                                    <div>
                                        <label className="block text-slate-600 text-sm font-medium mb-2 text-left">
                                            ອີເມວ ຫຼື ເບີໂທ (ຖ້າຕ້ອງການໃຫ້ຕອບກັບ)
                                        </label>
                                        <input 
                                            type="text" 
                                            placeholder="example@email.com" 
                                            className="w-full rounded-xl border-slate-200 border p-3.5 focus:ring-2 focus:ring-slate-400 focus:border-slate-400 outline-none text-slate-700 bg-slate-50/50"
                                            value={feedbackContact}
                                            onChange={(e) => setFeedbackContact(e.target.value)}
                                        />
                                    </div>
                                </div>

                                <div>
                                    <label className="block text-slate-600 text-sm font-medium mb-2 text-left">
                                        ຂໍ້ຄວາມ <span className="text-red-500">*</span>
                                    </label>
                                    <textarea 
                                        rows="5"
                                        required
                                        placeholder="ພິມຂໍ້ຄວາມແນະນຳ, ຕິຊົມ, ແຈ້ງບັນຫາ ຫຼື ໃຫ້ກຳລັງໃຈ..." 
                                        className="w-full rounded-xl border-slate-200 border p-4 focus:ring-2 focus:ring-slate-400 focus:border-slate-400 transition-all resize-none outline-none text-slate-700 bg-slate-50/50"
                                        value={feedbackMessage}
                                        onChange={(e) => setFeedbackMessage(e.target.value)}
                                    ></textarea>
                                </div>

                                <div className="flex justify-start">
                                    <button 
                                        type="submit"
                                        disabled={feedbackLoading}
                                        className="bg-slate-800 hover:bg-slate-900 text-white font-semibold py-3 px-8 rounded-xl flex items-center gap-2 transition-all disabled:opacity-70 shadow-sm"
                                    >
                                        {feedbackLoading ? (
                                            <><div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></div> ກຳລັງສົ່ງ...</>
                                        ) : (
                                            <><SendIcon /> ສົ່ງຂໍ້ຄວາມ</>
                                        )}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                )}
            </main>
              {/* ສ່ວນຂອງ Copyright ລຸ່ມສຸດຂອງເວັບ */}
            <footer className="mt-16 pb-8 text-center text-sm text-slate-400">
                <p>&copy; {new Date().getFullYear()} laolaw.com. ສະຫງວນລິຂະສິດທຸກປະການ.</p>
            </footer>
            
        </div>
    );
}
